function handleShareButton() {
  const shareBtn = document.querySelector('.custom-main-product__share');
  if (!shareBtn) return;
  shareBtn.addEventListener('click', () => {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      shareBtn.classList.add('copied');
      setTimeout(() => shareBtn.classList.remove('copied'), 1500);
    });
  });
}


function updateAndOpenCartDrawer() {
  const currentPath = window.location.pathname.split('?')[0];
  const sectionUrl = currentPath + '?section_id=cart-drawer';
  
  fetch(sectionUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.replaceWith(newDrawer);
        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }, 100);
      }
    });
}

function updateQuantityLimit() {
  const qtyInput = document.getElementById('quantity');
  const plusBtn = document.getElementById('qtyPlus');
  const addBtn = document.querySelector('.custom-main-product__add-btn');
  if (!qtyInput || !plusBtn || !addBtn) return;
  
  const variantInputs = document.querySelectorAll('.custom-main-product__variant-input');
  const variantIdInput = document.getElementById('variantId');
  let variantId;
  
  const checkedInput = Array.from(variantInputs).find(input => input.checked);
  if (checkedInput) {
    variantId = checkedInput.value;
  } else {
    variantId = variantIdInput.value;
  }
  
  const inventory = parseInt(qtyInput.dataset.inventory, 10);
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const item = cart.items.find(i => String(i.id) === String(variantId));
      const inCart = item ? item.quantity : 0;
      const maxAvailable = Math.max(inventory - inCart, 0);
      if (inCart === 0 || parseInt(qtyInput.value, 10) > maxAvailable) {
        qtyInput.value = Math.min(qtyInput.value, maxAvailable > 0 ? maxAvailable : 1);
      }
      qtyInput.max = maxAvailable;
      plusBtn.disabled = maxAvailable <= 1 || parseInt(qtyInput.value, 10) >= maxAvailable;
      addBtn.disabled = maxAvailable < 1;
    });
}

function handleQuantityButtons() {
  const minusBtn = document.getElementById('qtyMinus');
  const plusBtn = document.getElementById('qtyPlus');
  const qtyInput = document.getElementById('quantity');
  if (!minusBtn || !plusBtn || !qtyInput) return;
  minusBtn.addEventListener('click', () => {
    let value = parseInt(qtyInput.value, 10);
    if (value > 1) {
      qtyInput.value = value - 1;
      updateQuantityLimit();
    }
  });
  plusBtn.addEventListener('click', () => {
    let value = parseInt(qtyInput.value, 10);
    let max = parseInt(qtyInput.max, 10) || 99;
    if (value < max) {
      qtyInput.value = value + 1;
      updateQuantityLimit();
    }
  });
  updateQuantityLimit();
}

function handleAddToCart() {
  const addToCartForm = document.getElementById('addToCartForm');
  if (!addToCartForm) return;
  addToCartForm.addEventListener('submit', e => {
    e.preventDefault();
    
    const variantInputs = document.querySelectorAll('.custom-main-product__variant-input');
    const variantIdInput = document.getElementById('variantId');
    let variantId;
    
    const checkedInput = Array.from(variantInputs).find(input => input.checked);
    if (checkedInput) {
      variantId = checkedInput.value;
    } else {
      variantId = variantIdInput.value;
    }
    
    const quantity = document.getElementById('quantity').value;
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error('Error adding to cart');
        return response.json();
      })
      .then(() => {
        updateAndOpenCartDrawer();
        setTimeout(updateQuantityLimit, 500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
  });
}

let cartUpdateUnsubscriber = null;

function handleCartUpdate() {
  const addToCartForm = document.getElementById('addToCartForm');
  if (!addToCartForm) return;
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(updateQuantityLimit, 100);
    });
  }
}

function cleanupCartUpdate() {
  if (cartUpdateUnsubscriber) {
    cartUpdateUnsubscriber();
    cartUpdateUnsubscriber = null;
  }
}

function initProductImageSlider() {
  const slider = document.getElementById('productImageSlider');
  if (!slider) return;
  const slides = slider.querySelectorAll('.custom-main-product__image-slide');
  const prevBtn = document.getElementById('sliderPrev');
  const nextBtn = document.getElementById('sliderNext');
  const indicator = document.getElementById('sliderIndicator');
  let current = 0;
  let animating = false;
  
  window.productSliderCurrent = current;

  function showSlide(newIndex) {
    if (animating || newIndex === window.productSliderCurrent || newIndex < 0 || newIndex >= slides.length) return;
    animating = true;
    const oldSlide = slides[window.productSliderCurrent];
    const newSlide = slides[newIndex];
    oldSlide.classList.remove('active');
    newSlide.classList.add('active');
    oldSlide.classList.add('fade-out');
    newSlide.classList.add('fade-in');
    setTimeout(() => {
      oldSlide.classList.remove('fade-out');
      oldSlide.style.display = 'none';
      newSlide.classList.remove('fade-in');
      newSlide.style.display = 'block';
      current = newIndex;
      window.productSliderCurrent = newIndex;
      updateSliderControls();
      animating = false;
    }, 300);
  }

  function updateSliderControls() {
    if (indicator) {
      indicator.textContent = `${window.productSliderCurrent + 1} of ${slides.length}`;
    }
    if (prevBtn) prevBtn.disabled = window.productSliderCurrent === 0;
    if (nextBtn) nextBtn.disabled = window.productSliderCurrent === slides.length - 1;
  }

  function updateSlider(init) {
    slides.forEach((slide, idx) => {
      if (init) {
        slide.style.display = idx === window.productSliderCurrent ? 'block' : 'none';
        slide.classList.remove('fade-in', 'fade-out', 'active');
        if (idx === window.productSliderCurrent) slide.classList.add('active');
      }
    });
    updateSliderControls();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (window.productSliderCurrent > 0) {
        showSlide(window.productSliderCurrent - 1);
      }
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (window.productSliderCurrent < slides.length - 1) {
        showSlide(window.productSliderCurrent + 1);
      }
    });
  }

  let startX = null;
  let isTouching = false;

  slider.addEventListener('touchstart', e => {
    if (e.touches.length === 1) {
      startX = e.touches[0].clientX;
      isTouching = true;
    }
  });
  slider.addEventListener('touchmove', e => {
    if (!isTouching || startX === null) return;
    const dx = e.touches[0].clientX - startX;
    if (Math.abs(dx) > 10) {
      e.preventDefault();
    }
  }, { passive: false });
  slider.addEventListener('touchend', e => {
    if (!isTouching || startX === null) return;
    const endX = (e.changedTouches && e.changedTouches[0].clientX) || 0;
    const dx = endX - startX;
    if (Math.abs(dx) > 40) {
      if (dx < 0 && window.productSliderCurrent < slides.length - 1) {
        showSlide(window.productSliderCurrent + 1);
      } else if (dx > 0 && window.productSliderCurrent > 0) {
        showSlide(window.productSliderCurrent - 1);
      }
    }
    startX = null;
    isTouching = false;
  });

  updateSlider(true);
}

function updateProductImages(variantId) {
  const slider = document.getElementById('productImageSlider');
  if (!slider) return;
  
  const slides = slider.querySelectorAll('.custom-main-product__image-slide');
  if (slides.length === 0) return;
  
  let targetSlide = null;
  let slideIndex = -1;
  
  for (let i = 0; i < slides.length; i++) {
    const slide = slides[i];
    const img = slide.querySelector('img[data-variant-id]');
    if (img && img.dataset.variantId === variantId) {
      targetSlide = slide;
      slideIndex = i;
      break;
    }
  }
  
  if (targetSlide && slideIndex !== -1) {
    slides.forEach((slide, idx) => {
      slide.style.display = 'none';
      slide.classList.remove('active', 'fade-in', 'fade-out');
    });
    
    targetSlide.style.display = 'block';
    targetSlide.classList.add('active');
    
    if (window.productSliderCurrent !== undefined) {
      window.productSliderCurrent = slideIndex;
    }
    
    const indicator = document.getElementById('sliderIndicator');
    const prevBtn = document.getElementById('sliderPrev');
    const nextBtn = document.getElementById('sliderNext');
    
    if (indicator) {
      indicator.textContent = `${slideIndex + 1} of ${slides.length}`;
    }
    
    if (prevBtn) prevBtn.disabled = slideIndex === 0;
    if (nextBtn) nextBtn.disabled = slideIndex === slides.length - 1;
  }
}

function handleVariantSelector() {
  const variantInputs = document.querySelectorAll('.custom-main-product__variant-input');
  const variantIdInput = document.getElementById('variantId');
  const qtyInput = document.getElementById('quantity');
  const addBtn = document.querySelector('.custom-main-product__add-btn');
  const addBtnText = addBtn.querySelector('span');
  
  if (!variantInputs.length || !variantIdInput) return;
  
  variantInputs.forEach(input => {
    input.addEventListener('change', (e) => {
      if (e.target.checked) {
        const variantId = e.target.value;
        const price = e.target.dataset.price;
        const inventory = parseInt(e.target.dataset.inventory, 10);
        const available = e.target.dataset.available === 'true';
        const weightVariant = e.target.getAttribute('data-weight-variant') || '';
        const weightProductMetafield = e.target.getAttribute('data-weight-product-metafield') || '';
        const weightProduct = e.target.dataset.weightProduct || '';
        const weightUnit = e.target.dataset.weightUnit || '';
        
        variantIdInput.value = variantId;
        
        qtyInput.dataset.inventory = inventory;
        qtyInput.max = inventory;
        
        if (parseInt(qtyInput.value, 10) > inventory) {
          qtyInput.value = Math.min(inventory, 1);
        }
        
        addBtn.disabled = !available || inventory < 1;
        if (available && inventory > 0) {
          addBtnText.textContent = addBtnText.textContent.replace(/sold out|売り切れ/i, 'Add to cart');
        } else {
          addBtnText.textContent = addBtnText.textContent.replace(/add to cart|カートに追加/i, 'Sold out');
        }
        
        updatePriceDisplay(price);
        updateWeightDisplay(weightVariant, weightProductMetafield, weightProduct, weightUnit);
        updateProductImages(variantId);
        updateQuantityLimit();
      }
    });
  });
}

function updateWeightDisplay(weightVariant, weightProductMetafield, weightProduct, weightUnit) {
  const weightMobile = document.getElementById('productWeightMobile');
  const weightDesktop = document.getElementById('productWeightDesktop');
  
  let weightText = '';
  
  if (weightVariant && weightVariant.trim() !== '') {
    weightText = weightVariant;
  } else if (weightProductMetafield && weightProductMetafield.trim() !== '') {
    weightText = weightProductMetafield;
  } else if (weightProduct) {
    weightText = weightProduct + (weightUnit ? ' ' + weightUnit : '');
  }
  
  if (weightMobile && weightText) {
    weightMobile.innerHTML = weightText;
  }
  
  if (weightDesktop && weightText) {
    weightDesktop.innerHTML = weightText;
  }
}

function updatePriceDisplay(price) {
  const currencySymbolElement = document.getElementById('currencySymbol');
  const currencySymbol = currencySymbolElement ? currencySymbolElement.textContent.trim() : '€';
  
  const formatInfo = document.getElementById('currencyFormatInfo');
  const examplePrice = formatInfo ? formatInfo.dataset.examplePrice : '';
  
  let priceValue;
  const priceInMainCurrency = price / 100;
  
  const hasComma = examplePrice.includes(',');
  const hasDot = examplePrice.includes('.');
  
  let decimalSeparator = null;
  let thousandsSeparator = null;
  let decimals = 0;
  
  if (hasComma && hasDot) {
    const commaPos = examplePrice.indexOf(',');
    const dotPos = examplePrice.indexOf('.');
    if (commaPos < dotPos) {
      thousandsSeparator = ',';
      decimalSeparator = '.';
      decimals = examplePrice.length - dotPos - 1;
    } else {
      thousandsSeparator = '.';
      decimalSeparator = ',';
      decimals = examplePrice.length - commaPos - 1;
    }
  } else if (hasComma) {
    const afterComma = examplePrice.split(',')[1];
    if (afterComma && afterComma.length <= 2) {
      decimalSeparator = ',';
      decimals = afterComma.length;
    } else {
      thousandsSeparator = ',';
      decimals = 0;
    }
  } else if (hasDot) {
    const afterDot = examplePrice.split('.')[1];
    if (afterDot && afterDot.length <= 2) {
      decimalSeparator = '.';
      decimals = afterDot.length;
    } else {
      thousandsSeparator = '.';
      decimals = 0;
    }
  }
  
  if (decimals > 0 && decimalSeparator) {
    const fixedPrice = priceInMainCurrency.toFixed(decimals);
    if (thousandsSeparator) {
      const parts = fixedPrice.split('.');
      const integerPart = parseInt(parts[0]).toLocaleString('en-US');
      priceValue = integerPart.replace(/,/g, thousandsSeparator) + decimalSeparator + parts[1];
    } else {
      priceValue = fixedPrice.replace('.', decimalSeparator);
    }
  } else {
    const intPrice = Math.round(priceInMainCurrency);
    if (thousandsSeparator) {
      priceValue = intPrice.toLocaleString('en-US').replace(/,/g, thousandsSeparator);
    } else {
      priceValue = intPrice.toString();
    }
  }
  
  const allPriceItems = document.querySelectorAll('.price-item--regular');
  allPriceItems.forEach(item => {
    const currencySpan = item.querySelector('.price-currency');
    const valueSpan = item.querySelector('.price-value');
    if (currencySpan && valueSpan) {
      currencySpan.textContent = currencySymbol;
      valueSpan.textContent = priceValue;
    }
  });
}

function handleAccordionDetails() {
  const detailsElements = document.querySelectorAll('.custom-main-product__details');
  if (!detailsElements.length) return;

  detailsElements.forEach(details => {
    details.addEventListener('click', (e) => {
      if (e.target.closest('summary')) {
        e.preventDefault();
        
        const isCurrentlyOpen = details.hasAttribute('open');
        
        detailsElements.forEach(otherDetails => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });
        
        if (isCurrentlyOpen) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
          
          if (window.innerWidth <= 1024) {
            setTimeout(() => {
              details.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        }
      }
    });
  });
}

function initCustomMainProduct() {
  handleShareButton();
  handleAddToCart();
  handleQuantityButtons();
  handleCartUpdate();
  initProductImageSlider();
  handleAccordionDetails();
  handleVariantSelector();
  
  const selectedInput = document.querySelector('.custom-main-product__variant-input:checked');
  if (selectedInput) {
    const weightVariant = selectedInput.getAttribute('data-weight-variant') || '';
    const weightProductMetafield = selectedInput.getAttribute('data-weight-product-metafield') || '';
    const weightProduct = selectedInput.dataset.weightProduct || '';
    const weightUnit = selectedInput.dataset.weightUnit || '';
    updateWeightDisplay(weightVariant, weightProductMetafield, weightProduct, weightUnit);
  }
  
  window.addEventListener('beforeunload', cleanupCartUpdate);
}

document.addEventListener('DOMContentLoaded', initCustomMainProduct);